export const common = {
  // Navbar
  nav_inicio: 'Inicio',
  nav_sobre_nosotros: 'Sobre Nosotros',
  nav_productos: 'Productos',
  nav_testimonios: 'Testimonios',
  nav_contacto: 'Contacto',
  
  // Hero
  hero_title: 'Tienda de Productos Mexicanos, Hondureños, Salvadoreños y Nicaragüenses en Indianápolis',
  hero_subtitle: 'Descubre la auténtica esencia de México, Honduras, El Salvador y Nicaragua en el corazón de Indianápolis. Amplia variedad de productos latinos, muchos de ellos difíciles de encontrar en otras tiendas.',
  hero_whatsapp: 'Escríbenos por WhatsApp',
  hero_location: 'Ver Ubicación',
  hero_authentic: 'Productos Auténticos',
  hero_prices: 'Mejores Precios',
  hero_service: 'Atención Cercana',
  hero_shipping: 'Envíos de Cajas',
  
  // About
  about_badge: 'Sobre Nosotros',
  about_title: 'Tu Tienda de',
  about_title_highlight: 'Productos Centroamericanos',
  about_title_suffix: 'en Indianápolis',
  about_p1: 'Somos una tienda especializada en productos mexicanos, hondureños, salvadoreños y nicaragüenses ubicada en Indianápolis. Traemos productos auténticos directamente desde Centroamérica para que puedas disfrutar de los sabores de tu tierra.',
  about_p2: 'Manejamos una amplia variedad de productos centroamericanos: dulces tradicionales, botanas, abarrotes, bebidas típicas, salsas artesanales, chiles, condimentos y mucho más. Muchos de nuestros productos son difíciles de encontrar en otras tiendas de la zona.',
  about_p3: 'Ofrecemos algunos de los mejores precios del mercado porque queremos que toda la comunidad latina tenga acceso a productos de calidad a precios justos. Nuestro servicio es cercano, amable y familiar - hablamos español e inglés.',
  about_p4: 'Estamos ubicados en una zona tranquila y familiar de Indianápolis, ideal para visitar con toda tu familia. Al entrar a nuestra tienda, sentirás que estás en una tienda de tu país. ¡Te esperamos!',
  about_stat_products: 'Productos',
  about_stat_countries: 'Países',
  about_stat_authentic: 'Auténtico',
  
  // Products
  products_badge: 'Nuestros Productos',
  products_title: 'Productos Auténticos de México y Centroamérica',
  products_subtitle: 'Descubre nuestra amplia selección de productos mexicanos, hondureños, salvadoreños y nicaragüenses. Todo lo que necesitas para preparar tus platillos favoritos está aquí.',
  products_cat1_title: 'Tortillas y Masa',
  products_cat1_desc: 'Tortillas frescas de maíz y harina, masa para tamales, totopos, y auténticos chips de tortilla hechos al estilo tradicional.',
  products_cat2_title: 'Chiles y Salsas',
  products_cat2_desc: 'Amplia variedad de chiles secos y frescos (jalapeño, serrano, habanero, chipotle), salsas picantes artesanales, y moles tradicionales de Oaxaca.',
  products_cat3_title: 'Frijoles y Granos',
  products_cat3_desc: 'Frijoles negros, pintos, bayos, lentejas, arroz mexicano, y granos básicos de alta calidad de la cocina latinoamericana.',
  products_cat4_title: 'Especias y Condimentos',
  products_cat4_desc: 'Comino, orégano mexicano, canela, achiote, epazote, y mezclas auténticas de especias para dar sabor a tus platillos favoritos.',
  products_cat5_title: 'Dulces y Botanas',
  products_cat5_desc: 'Dulces típicos mexicanos (mazapán, tamarindo, pulparindo), boquitas nicaragüenses, churros salvadoreños, y botanas tradicionales hondureñas.',
  products_cat6_title: 'Productos de Temporada',
  products_cat6_desc: 'Pan de muerto, rosca de reyes, tamales navideños, ingredientes para pozole, y productos especiales para las celebraciones tradicionales mexicanas y centroamericanas durante todo el año.',
  products_cta_title: '¿No Encuentras lo que Buscas?',
  products_cta_subtitle: 'Tenemos cientos de productos más en nuestra tienda. Visítanos o contáctanos para consultar disponibilidad de productos específicos.',
  products_cta_contact: 'Contáctanos',
  products_cta_whatsapp: 'WhatsApp',
  
  // Contact
  contact_badge: 'Contacto y Ubicación',
  contact_title: 'Visítanos o Contáctanos',
  contact_subtitle: 'Estamos aquí para atenderte. Ven a conocernos o escríbenos, con gusto te atenderemos.',
  contact_info_title: 'Información de Contacto',
  contact_address: 'Dirección',
  contact_address_line1: 'Tienda La Bonita Market',
  contact_address_line2: '4051 Carson Ave',
  contact_address_line3: 'Indianápolis, IN 46227',
  contact_hours: 'Horario de Atención',
  contact_hours_time: 'Lunes a Domingo: 8:00 AM - 10:30 PM',
  contact_phone: 'Teléfono',
  contact_email: 'Correo',
  contact_whatsapp_btn: 'Enviar Mensaje por WhatsApp',
  contact_form_title: 'Envíanos un Mensaje',
  contact_name: 'Nombre Completo',
  contact_name_placeholder: 'Tu nombre',
  contact_email_label: 'Correo Electrónico',
  contact_email_placeholder: 'tu@correo.com',
  contact_phone_label: 'Teléfono',
  contact_phone_placeholder: '(123) 456-7890',
  contact_message: 'Mensaje',
  contact_message_placeholder: '¿Cómo podemos ayudarte?',
  contact_send: 'Enviar Mensaje',
  contact_sending: 'Enviando...',
  contact_success: '¡Mensaje enviado con éxito! Te contactaremos pronto.',
  contact_error: 'Hubo un error al enviar el mensaje. Por favor intenta de nuevo.',
  contact_form_name: 'Nombre Completo',
  contact_form_name_placeholder: 'Tu nombre',
  contact_form_email: 'Correo Electrónico',
  contact_form_email_placeholder: 'tu@correo.com',
  contact_form_message: 'Mensaje',
  contact_form_message_placeholder: '¿Cómo podemos ayudarte?',
  contact_form_max_chars: 'Máximo 500 caracteres',
  contact_form_submit: 'Enviar Mensaje',
  contact_form_sending: 'Enviando...',
  contact_form_success: '¡Mensaje enviado con éxito! Te contactaremos pronto.',
  contact_form_error: 'Hubo un error al enviar el mensaje. Por favor intenta de nuevo.',
  contact_final_title: 'Visítanos y Vive la Experiencia de una Tienda Mexicana en Indianápolis',
  contact_final_subtitle: 'Te esperamos con los brazos abiertos. Ven a descubrir todos los productos mexicanos que tenemos para ti y tu familia. ¡Te sentirás como en casa!',
  contact_final_location: 'Ver Ubicación',
  contact_final_whatsapp: 'Contactar por WhatsApp',
  
  // Testimonials
  testimonials_badge: 'TESTIMONIOS',
  testimonials_title: 'Lo Que Dicen',
  testimonials_title_highlight: 'Nuestros Clientes',
  testimonials_subtitle: 'La satisfacción de nuestros clientes es nuestra mayor recompensa. Lee lo que opinan las familias que nos visitan.',
  testimonials_cta_text: '¿Quieres ser parte de nuestra familia de clientes satisfechos?',
  testimonials_cta_button: 'Contáctanos Ahora',

  // Shipping Section
  shipping_badge: 'SERVICIO DE ENVÍOS',
  shipping_title: 'Envíos Seguros con',
  shipping_title_highlight: 'Paquetería Hernández',
  shipping_subtitle: 'Conectamos tu hogar con Centroamérica de forma rápida y confiable',
  shipping_mexico: 'México',
  shipping_guatemala: 'Guatemala',
  shipping_salvador: 'El Salvador',
  shipping_honduras: 'Honduras',
  shipping_available: 'Disponible',
  shipping_days: 'días',
  shipping_feature1_title: 'Seguro Incluido',
  shipping_feature1_desc: 'Todas las cajas viajan protegidas con seguro básico sin costo adicional',
  shipping_feature2_title: 'Rastreo en Tiempo Real',
  shipping_feature2_desc: 'Monitorea tu envío desde que sale hasta que llega a su destino',
  shipping_feature3_title: 'Empaque Profesional',
  shipping_feature3_desc: 'Asesoría gratuita para empacar correctamente tus productos',
  shipping_cta: 'Cotizar Mi Envío Ahora',
  
  // Why Choose Us
  why_badge: 'Por Qué Elegirnos',
  why_title: 'Tu Mejor Opción para',
  why_title_highlight: 'Productos Centroamericanos',
  why_subtitle: 'Somos más que una tienda, somos un pedacito de México, Honduras, El Salvador y Nicaragua en Indianápolis.',
  why_reason1_title: 'Productos Difíciles de Encontrar',
  why_reason1_desc: 'Traemos productos auténticos directamente desde México, Honduras, El Salvador y Nicaragua que no encontrarás fácilmente en otras tiendas de Indianápolis.',
  why_reason2_title: 'Precios Justos y Competitivos',
  why_reason2_desc: 'Ofrecemos excelentes precios para que toda la comunidad latina tenga acceso a productos de calidad sin gastar de más. Algunos de los mejores precios del mercado.',
  why_reason3_title: 'Servicio Cercano y Familiar',
  why_reason3_desc: 'Atención amable en español e inglés. Te tratamos como familia porque entendemos lo importante que es sentirse como en casa. Siempre listos para ayudarte.',
  why_reason4_title: 'Envíos con Paquetería Hernández',
  why_reason4_desc: 'Enviamos cajas a México, Guatemala, El Salvador y Honduras de forma rápida y segura. Conectamos tu hogar con tu país con rastreo en tiempo real y seguro incluido.',
  why_additional_title: 'Más de 500 Productos de 4 Países',
  why_additional_subtitle: 'Nuestra tienda cuenta con una amplia variedad de productos auténticos de México, Honduras, El Salvador y Nicaragua. Desde abarrotes básicos hasta productos especiales que te harán sentir como en casa.',
  why_country_mexico: 'México',
  why_country_honduras: 'Honduras',
  why_country_salvador: 'El Salvador',
  why_country_nicaragua: 'Nicaragua',
  
  // Footer
  footer_about_title: 'Sobre Nosotros',
  footer_about_text: 'Tu tienda de confianza para productos mexicanos, hondureños, salvadoreños y nicaragüenses en Indianápolis.',
  footer_quick_links: 'Enlaces Rápidos',
  footer_contact_title: 'Contacto',
  footer_hours_title: 'Horario',
  footer_hours_time: 'Lunes a Domingo: 8:00 AM - 10:30 PM',
  footer_rights: 'Todos los derechos reservados.',
  footer_powered: 'Powered by Readdy',
  
  // Grand Opening
  grand_opening_badge: '¡GRAN APERTURA!',
  grand_opening_title: '¡Celebrando la Apertura de Nuestra Nueva Ubicación!',
  grand_opening_subtitle: '🎉 DESCUENTOS 🎊',
  grand_opening_subtitle2: 'ESPECIALES',
  grand_opening_limited: '¡TIEMPO LIMITADO!',
  grand_opening_exclusive: 'Ofertas EXCLUSIVAS para compras presenciales',
  grand_opening_description: 'Visítanos en nuestra nueva ubicación y aprovecha estos increíbles descuentos',
  grand_opening_location: 'VER UBICACIÓN',
  grand_opening_offers: 'CONSULTAR OFERTAS',
};
